export default {
    language: 'fi-FI',
    navigation: 'Takaisin',
    home: {
        title: 'Yacht Maalilaskin',
        subtitle:
            'Anna meidän auttaa sinua valitsemaan paras antifouling-maali ja laskemaan tarvitsemasi määrä',
        findProduct: 'Löydä tuote',
        calculateVolume: 'Laske määrä'
    },
    find: {
        questions: {
            type: 'Veneesi <strong>tyyppi</strong>?',
            material: 'Veneen <strong>materiaali</strong>?',
            sailFrequency: '<strong>Miten usein</strong> käytät venettäsi?',
            paintLocation: '<strong>Missä</strong> maalaat venettäsi?',
            waterType: '<strong>Millaisen veden</strong>käytät venettäsi?'
        },
        answers: {
            help: 'Tarvitsetko apua antifouling-maalin valinnassa?',

            type: [
                {
                    label: 'Purjevene',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Moottorivene (hidas)',
                    sublabel: 'enintään 20 solmua',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Moottorivene (nopea)',
                    sublabel: 'nopeampi kuin 20 solmua',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Lasikuitu',
                    value: 'plastic'
                },
                {
                    label: 'Teräs',
                    value: 'iron'
                },
                {
                    label: 'Puu',
                    value: 'wood'
                },
                {
                    label: 'Alumiini',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Harvoin',
                    sublabel: '1–2 kertaa kuukaudessa tai harvemmin',
                    value: 'low'
                },
                {
                    label: 'Usein',
                    sublabel: '1–2 kertaa viikossa',
                    value: 'medium'
                },
                {
                    label: 'Aika usein',
                    sublabel: 'Lähes joka päivä',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Valitse maa',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Kanada', value: 'en-CA' },
                        { label: 'Tanska', value: 'da-DK' },
                        { label: 'Espanja', value: 'es-ES' },
                        { label: 'Suomi', value: 'fi-FI' },
                        { label: 'Saksa', value: 'de-DE' },
                        { label: 'Kreikka', value: 'el-GR' },
                        { label: 'Kroatia', value: 'hr-HR' },
                        { label: 'Norja', value: 'nb-NO' },
                        { label: 'Alankomaat', value: 'nl-NL' },
                        { label: 'Ruotsi - itärannikko', value: 'sv-SE_e' },
                        { label: 'Ruotsi - länsirannikko', value: 'sv-SE_w' },
                        { label: 'Ruotsi - järvi', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Meri/valtameri', value: 'sea/ocean' },
                { label: 'Joki', value: 'rivers' },
                { label: 'Järvi', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Suosittelemme',
            selection: {
                title: 'Valintasi',
                type: 'Venessi tyyppi',
                waterType: 'Vesityyppi',
                material: 'Materiaali',
                sailFrequency: 'Toiminta',
                country: 'Maa'
            },
            category: {
                premium: 'Korkealuokkainen',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Paras osto',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Paras osto',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Lisätietoja',
            whereToBuy: 'Ostopaikat',
            email: 'Sähköpostiosoite',
            send: 'Lähetä',
            feedback: {
                title: 'Oliko näistä tiedoista apua??',
                yes: 'Joo',
                no: 'Ei',
                comment: 'Kommentti',
                placeholder: 'Kommentti'
            },
            recommendation: {
                title: 'Lähettäkää suositus sähköpostiin'
            },
            calculateVolume: 'Laske määrä'
        }
    },
    calculate: {
        letsCalculate: 'Laske',
        questions: {
            antifouling: 'Valitse Antifouling-maalit',
            keelType: 'Kölin<strong> tyyppi</strong>?',
            dimensions: 'Veneen <strong>mitat</strong>'
        },
        answers: {
            keelType: [
                {
                    label: 'Eväköli',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Pitkä köli',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Yksittäiset mitat'
                },
                {
                    title: 'TAI vedenalainen pinta-ala m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Yksikkö',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Vesilinjan pituus'
                },
                {
                    type: 'beam',
                    label: 'Leveys'
                },
                {
                    type: 'draft',
                    label: 'Syväys'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Ehdotettu määrä',
            selection: {
                title: 'Valintasi',
                antifouling: 'Antifouling',
                type: 'Veneesi tyyppi',
                material: 'Materiaali',
                sailFrequency: 'Toiminta',
                country: 'Maa',
                keelType: 'Kölin tyyppi',
                dimensions: 'Veneen mitat'
            },
            category: {
                premium: 'Korkealuokkainen',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Paras osto',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Paras osto',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Ehdotettu määrä',
            suggestedAmountTwoCoats: 'Ehdotettu määrä (2 kerrosta)',
            oneCoat: '(1 kerros)',
            fiveCoats: '(5 kerrosta)',
            primerAltTiecoatSilic: 'Muista aina käyttää Tiecoatia!',
            primerAltSilicSealSilic:
                '<strong>ESIMERKKI 2</strong><br/>Levittäminen vanhan hyväkuntoisen antifouling-pinnoitteen päälle - helppo siirtyä Silic One -järjestelmään',
            primerAlLightSilic:
                '<strong>ESIMERKKI 1</strong><br/>Vanhan antifouling-pinnoitteen poisto ja koko järjestelmällä käsitteleminen & uusi vene ilman epoksia',

            primerAltTiecoat:
                '<strong>TAPAUS 2: Vaihe 2</strong><br/>...ja tämän jälkeen kerros Conversion Primeriä.',
            primerAltSilicSeal:
                '<strong>TAPAUS 2: Vaihe 1</strong><br/>Veneet ilman antifouling-maalia, maalaa ensin kerros Light Primeriä',
            primerAlLight:
                '<strong>TAPAUS 1</strong><br/>Maalaaminen vanhan, hyväkuntoisen antifouling-maalin päälle.',
            primer:
                'Onko veneen runko pahoin vaurioitunut tai maalaatko veneen ensimmäistä kertaa? Tarvitset...',
            whereToBuy: 'Ostopaikat',
            email: 'Sähköpostiosoite',
            send: 'Lähettää',
            or: 'TAI',
            feedback: {
                title: 'Oliko näistä tiedoista apua??',
                yes: 'Joo',
                no: 'Ei',
                comment: 'Kommentti',
                placeholder: 'Kommentti'
            },
            recommendation: {
                title: 'Lähettäkää suositus sähköpostiin'
            },
            calculateVolume: 'Laske määrä'
        }
    },
    map: {
        country: 'Maa',
        city: 'Kaupunki',
        getDirections: 'Antakaa ohjeet',
        placeholder: 'Kaikki kaupungit...'
    },
    footer: 'Hempel Yacht - kaikki mitä sinun tulee tietää veneen maalaamisesta'
}
